(() => {
  'use strict';
  function mount(scope) {
    scope.querySelectorAll('[data-pdp-recommendations]:not([data-ready])').forEach(root => {
      root.dataset.ready = '';
      const rail = root.querySelector('[data-pdp-rail]'), button = root.querySelector('[data-load-more]'), status = root.querySelector('[data-load-status]');
      const lifecycle = new AbortController();
      window.HobbytronMerchandising?.mount(rail, root.querySelector('h2').textContent, lifecycle.signal);
      const seen = new Set([...rail.children].map(card => card.dataset.itemKey));
      let busy = false;
      button.addEventListener('click', async () => {
        if (busy || !root.dataset.nextUrl) return;
        busy = true; button.disabled = true; button.textContent = button.dataset.loading;
        try {
          const url = new URL(root.dataset.nextUrl, location.href);
          url.searchParams.set('section_id', root.dataset.sectionId);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, {signal: lifecycle.signal});
          if (!response.ok) throw Error('Load failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = doc.querySelector('[data-pdp-recommendations]');
          if (!next) throw Error('Missing recommendations');
          let added = 0;
          for (const card of next.querySelector('[data-pdp-rail]').children) {
            if (seen.has(card.dataset.itemKey)) continue;
            seen.add(card.dataset.itemKey); rail.append(card.cloneNode(true)); added++;
          }
          root.dataset.nextUrl = next.dataset.nextUrl || '';
          button.hidden = !root.dataset.nextUrl;
          button.textContent = button.dataset.label;
          status.textContent = `${added} products loaded.`;
        } catch (error) {
          if (error.name !== 'AbortError') {button.textContent = button.dataset.retry; status.textContent = button.dataset.retry;}
        } finally {busy = false; button.disabled = false;}
      }, {signal: lifecycle.signal});
      document.addEventListener('shopify:section:unload', event => {if(event.target.contains(root)) lifecycle.abort();}, {signal: lifecycle.signal});
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
